import { numberFormatMap } from '@databases/collab/convert/to-collab';
import { NumberFormat } from '@databases/model/field';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setFieldSettingsNumberFormat: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_SETTINGS_NUMBER_FORMAT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];
    const oldFormat = field.numberFormat;
    const newFormat = numberFormatMap[change.newValue.format];

    field.numberFormat = newFormat;

    const isChangingFromPercent =
      oldFormat === NumberFormat.PERCENT && newFormat !== NumberFormat.PERCENT;
    const isChangingToPercent =
      oldFormat !== NumberFormat.PERCENT && newFormat === NumberFormat.PERCENT;

    if (isChangingFromPercent || isChangingToPercent) {
      for (const entryId in db.entriesById) {
        const entry = db.entriesById[entryId];
        const value = entry.getValue(change.fieldId);

        if (value && value.value) {
          const currentValue = Number(value.value);
          if (!isNaN(currentValue)) {
            let convertedValue: number;

            if (isChangingFromPercent) {
              convertedValue = parseFloat((currentValue * 100).toFixed(10));
            } else {
              convertedValue = parseFloat((currentValue / 100).toFixed(10));
            }

            (value as any).value = convertedValue.toString();
          }
        }
      }
    }
  });
};
